import { useTranslation } from "react-i18next";

const BlogHero = () => {
  const { t } = useTranslation();
  return (
    <article className="relative h-[70vh] flex items-center justify-center">
      <div className="absolute w-full h-full">
        <img src="/assets/blog.png" alt="aboutUsHero" className="w-full h-full" />
      </div>
      <div className="relative z-10 flex w-full h-full bg-black/50">
        <div className="flex items-center w-11/12 mx-auto">
          <section className="space-y-5 font-bold text-white max-w-[830px]">
            <h1 className=" text-[20px] md:text-[40px] font-bold">
              {t("logisticsTips")}
            </h1>
            <p className="text-[16px] md:text-[24px] ">{t("stayUpToDate")}</p>
            <button className="px-4 py-2 bg-white rounded-lg md:px-8 md:py-4 text-mainBlue hover:bg-white/90">
              {t("exploreBlog")}
            </button>
          </section>
        </div>
      </div>
    </article>
  );
};

export default BlogHero;
